import { Button, styled } from '@mui/material';

export const BarW = styled('div')`
  backdrop-filter: blur(10px);
  border-radius: 12px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media (max-width: 1023px) {
    padding: 16px;
    padding-top: 0px;
  }
`;

export const Title = styled('span')`
  display: block;
  font-weight: 700;
  font-size: 24px;
  line-height: 28px;
  color: ${({ theme }) => theme.palette.text.primary};
  margin-bottom: 24px;

  @media (max-width: 1023px) {
    font-size: 20px;
    line-height: 24px;
  }
`;

export const ButtonsRow = styled('div')`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  @media (max-width: 1023px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const ActionButton = styled(Button)`
  border: 1px solid ${({ theme }) => theme.palette.divider};
  border-radius: 8px;
  background: ${({ theme }) => theme.palette.white.main};
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 14px;
  font-weight: 400;
  text-transform: none;
  padding: 6px 16px;
  white-space: nowrap;

  &:hover {
    background: ${({ theme }) => theme.palette.action.hover};
    border-color: ${({ theme }) => theme.palette.divider};
  }
`;
